import axiosInstance from '../../../config/axios.config';

/**
 * Commission Wallet Payment Service
 * Handles payment operations for commission wallet add money feature.
 * Used by PaymentGateway.js for cross-tenant payment processing.
 */
export const commissionWalletPaymentService = {
    /**
     * Decrypt payment token and get payment context
     * Called on PaymentGateway page to get order details
     */
    async decryptToken(token) {
        try {
            const response = await axiosInstance.post('/leadflow/wallet/add-money/decrypt-token', {
                token: token
            });
            return response.data;
        } catch (error) {
            console.error('Commission wallet token decryption failed:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to decrypt payment token'
            };
        }
    },

    /**
     * Confirm payment after Razorpay success
     * Called after successful Razorpay payment to add money to wallet
     */
    async confirmPayment(paymentData) {
        try {
            const response = await axiosInstance.post('/leadflow/wallet/add-money/verify', {
                order_id: paymentData.razorpay_order_id,
                payment_id: paymentData.razorpay_payment_id,
                signature: paymentData.razorpay_signature,
                payment_confirm_token: paymentData.payment_confirm_token
            });
            return response.data;
        } catch (error) {
            console.error('Commission wallet payment confirmation failed:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Payment confirmation failed'
            };
        }
    },

    /**
     * Create add money order (initiate Razorpay order)
     * Called from Commission Wallet page
     */
    async createAddMoneyOrder(amount) {
        try {
            const response = await axiosInstance.post('/leadflow/wallet/add-money', {
                amount: amount
            });
            return response.data;
        } catch (error) {
            console.error('Create add money order failed:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to create payment order'
            };
        }
    },

    /**
     * Generate payment token for cross-tenant redirect
     * Called after createAddMoneyOrder to get redirect URL
     */
    async generatePaymentToken(orderData) {
        try {
            const response = await axiosInstance.post('/leadflow/wallet/add-money/generate-token', orderData);
            return response.data;
        } catch (error) {
            console.error('Generate payment token failed:', error);
            return {
                success: false,
                error: error.response?.data?.message || 'Failed to generate payment token'
            };
        }
    }
};
